import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
  cardContent: {
    padding: 0,
  },
  justGrid: {
    width: 'auto',
  },
  accountingCategoryTitle: {
    fontWeight: 400,
  },
  headerClassName: {
    fontWeight: 700,
  },
  total: {
    fontWeight: 500,
  },
  code: {
    color: grey[500],
  },
}));

export default useStyles;
